// The purpose of this component is to create a wrapper around the Material UI Avatar component
// So that we can easily default to using the initials of the user with a magenta background,
// instead of the boring grey faceless avatar.
// For more info on how default behavior for the Material Avatar component works look here:
// https://material-ui.com/components/avatars/

import { Avatar as MuiAvatar, makeStyles } from "@material-ui/core";
import { AvatarProps as MuiAvatarProps } from "@material-ui/core/Avatar";
import { createStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";
import {
    UnusedMuiEvents,
    UnusedMuiStandardProps,
    UnusedAriaProps,
} from "../types";

import { baseColors } from "../styles";

const useStyles = makeStyles(
    () =>
        createStyles({
            root: {},
            defaultAvatar: {
                backgroundColor: baseColors.magenta,
                color: baseColors.white,
            },
        }),
    { name: "Avatar" }
);

export type AvatarProps = {
    src?: string;
    alt: string;
    initials: string;
} & Omit<
    MuiAvatarProps,
    UnusedMuiEvents | UnusedMuiStandardProps | UnusedAriaProps
>;

export const Avatar = (props: AvatarProps) => {
    const { className: classNameProp, src, alt, initials } = props;

    const classes = useStyles({});

    const avatarClassNames = classnames(
        { [classes.defaultAvatar]: !src },
        classNameProp
    );

    return (
        <MuiAvatar src={src} alt={alt} className={avatarClassNames}>
            {initials}
        </MuiAvatar>
    );
};
